import axios from 'axios';
import config from '../config';

// Handles all API calls with jsonwebtoken authentication
export default async function (method, url, data, language, app_name) {
  return await axios.request({
    baseURL: config.api.base_url,
    url,
    method,
    data,
    timeout: 10000, // 10 seconds timeout
    headers: {
      'Accept-Language': language,
      'x-app-id': app_name,
    },
  });
}
